import $api from "@/core/services/ApiService";
import type {
  TicketsListParams,
  SendReply,
  CreateTicket,
  UpdateTicket,
} from "@/core/services/api/interfaces/manager/Ticket";
import { AxiosRequestConfig, AxiosResponse } from "axios";

class TicketEndpoint {
  public list(params: TicketsListParams): Promise<AxiosResponse> {
    return $api.get("manager/tickets", params);
  }

  public latest(): Promise<AxiosResponse> {
    return $api.get("manager/tickets/latest");
  }

  public view(ticket_id: string): Promise<AxiosResponse> {
    return $api.get(`manager/tickets/${ticket_id}`);
  }

  public create(data: CreateTicket): Promise<AxiosResponse> {
    const formData = new FormData();
    for (const key in data) {
      const value = data[key];
      if (Array.isArray(value)) {
        const arrayKey = `${key}[]`;
        value.forEach((arrayData) => {
          formData.append(arrayKey, arrayData);
        });
      } else {
        formData.append(key, value);
      }
    }
    return $api.direct({
      url: "manager/tickets",
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  public update(
    ticket_id: string | number,
    data: UpdateTicket
  ): Promise<AxiosResponse> {
    return $api.put(`manager/tickets/${ticket_id}`, data);
  }

  public threads(
    ticket_id: string | number,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    return $api.get(`manager/tickets/${ticket_id}/threads`, params);
  }

  public thread(
    ticket_id: string | number,
    thread_id: string | number
  ): Promise<AxiosResponse> {
    return $api.get(`manager/tickets/${ticket_id}/threads/${thread_id}`);
  }

  public reply(
    ticket_id: string | number,
    data: SendReply
  ): Promise<AxiosResponse> {
    return $api.post(`manager/tickets/${ticket_id}/reply`, data);
  }

  public attachments(ticket_id: string | number): Promise<AxiosResponse> {
    return $api.get(`manager/tickets/${ticket_id}/attachments`);
  }

  public attachmentContent(
    ticket_id: string | number,
    attachment_id: string | number
  ) {
    return $api.direct({
      url: `manager/tickets/${ticket_id}/attachments/${attachment_id}/content`,
      method: "GET",
      responseType: "blob",
    });
  }
}

export default TicketEndpoint;
